module.exports = __webpack_public_path__ + "static/media/iconRed.10d4f516.svg";